import ApproveSyndicationLimitContainer from 'containers/ApproveSyndicationLimit'
import React from 'react'

const ApproveSyndicationLimitPage = () => <ApproveSyndicationLimitContainer />

export default ApproveSyndicationLimitPage
